<template>
  <MainLayout >
    <router-view />
  </MainLayout>
</template>

<script setup lang="ts">
import MainLayout from './views/MainLayout.vue'
</script>